import { useLazyQuery } from '@apollo/client';
import { useCallback } from 'react';

import type { FilterOptionsInput } from '../../utils';
import { VERIFY_LINE_ITEM_IN_FILTERS } from './queries';

interface VerifyLineItemResult {
  verifyLineItemInFilters: (lineItemId: string, filterOptions: FilterOptionsInput) => void;
  verificationTotal: number | null;
  verificationLoading: boolean;
}

export function useVerifyLineItemInFilters(): VerifyLineItemResult {
  const [executeQuery, { data, loading }] = useLazyQuery(VERIFY_LINE_ITEM_IN_FILTERS, {
    fetchPolicy: 'no-cache',
  });

  const verifyLineItemInFilters = useCallback(
    (lineItemId: string, filterOptions: FilterOptionsInput) => {
      const { selectedIdList: _removed, ...filtersWithoutPin } = filterOptions || {};
      executeQuery({
        variables: {
          filterOptions: {
            ...filtersWithoutPin,
            idList: [lineItemId],
          },
        },
      });
    },
    [executeQuery]
  );

  return {
    verifyLineItemInFilters,
    verificationTotal: data?.lineItems?.total ?? null,
    verificationLoading: loading,
  };
}
